import Layout from '@/views/Layout/index.vue'
const DataPage = () => import('@/views/DataPage/index.vue')
const Clear = () => import('@/views/DataPage/Clear/index.vue')
const Analysis = () => import('@/views/DataPage/Analysis/index.vue')
const AttendanceRecord = () => import('@/views/DataPage/AttendanceRecord');
const ClassData = ()=> import('@/views/DataPage/ClassData/index.vue')
export default {
    path: '/data',
    component: Layout,
    children: [
      {
        path: '',
        component: DataPage,
        children: [
          {
            path: '',
            component: Clear,
          },
          {
            path: 'analysis',
            component: Analysis,
          },{
            path: 'attendanceRecord',
            component: AttendanceRecord,
          },{
            path: 'retentionOrLoss',
            component: ClassData,
          },
        ]
      }
    ]
  }
